import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as React from 'react';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};










export type AuthAndClient = {
  client?: Maybe<Client>;
  authentication_type?: Maybe<AuthenticationType>;
  existing_user: Scalars['Boolean'];
};

export enum AuthenticationType {
  Auth = 'auth',
  Sso = 'sso'
}

export type Client = {
  id: Scalars['ID'];
  title: Scalars['String'];
  subdomain?: Maybe<Scalars['String']>;
  email_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  content_domains?: Maybe<Array<Maybe<Scalars['String']>>>;
  client_status: ClientStatus;
  authentication_type: AuthenticationType;
  sso_configuration?: Maybe<SsoConfiguration>;
  allow_user_signup: Scalars['Boolean'];
  departments_in_signup: Scalars['Boolean'];
  departments_in_signup_required: Scalars['Boolean'];
  locations_in_signup: Scalars['Boolean'];
  locations_in_signup_required: Scalars['Boolean'];
  support_multiple_languages: Scalars['Boolean'];
  allow_user_invites: Scalars['Boolean'];
  default_timezone?: Maybe<Scalars['String']>;
  default_language?: Maybe<Scalars['String']>;
  image?: Maybe<S3Object>;
  social_media_policy_enabled?: Maybe<Scalars['Boolean']>;
  social_media_policy?: Maybe<Scalars['String']>;
  social_media_policy_title?: Maybe<Scalars['String']>;
  social_media_policy_url?: Maybe<Scalars['String']>;
  public_post_page?: Maybe<Scalars['Boolean']>;
  public_post_details?: Maybe<Scalars['Boolean']>;
};

export type ClientInvitation = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  invitation_status: ClientInvitationStatus;
  subject?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  email_from_address?: Maybe<Scalars['String']>;
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
  last_sent_at?: Maybe<Scalars['Int']>;
  retries?: Maybe<Scalars['Int']>;
  accepted_at?: Maybe<Scalars['Int']>;
  accepted_by_user_id?: Maybe<Scalars['ID']>;
};

/**   Client invitations */
export enum ClientInvitationStatus {
  Active = 'active',
  Deleted = 'deleted',
  Accepted = 'accepted'
}

export type ClientRequest = {
  id: Scalars['ID'];
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
  request_status: ClientRequestStatus;
  created_at: Scalars['Int'];
  updated_at: Scalars['Int'];
};

/**   Client requests */
export enum ClientRequestStatus {
  Active = 'active',
  Accepted = 'accepted',
  Rejected = 'rejected'
}

export enum ClientStatus {
  Active = 'active',
  Disabled = 'disabled'
}

export type ContentObject = {
  post_type: PostType;
  content_hash?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  body?: Maybe<Scalars['String']>;
  photos?: Maybe<Array<Maybe<S3Object>>>;
  media?: Maybe<MediaObject>;
  media_type?: Maybe<Scalars['String']>;
  video_url?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  metadata_keys?: Maybe<Array<Maybe<MetadataKey>>>;
  url_metadata?: Maybe<UrlMetadata>;
  primary_url_metadata_image?: Maybe<Scalars['Int']>;
  /**   TODO: Check with brandon to see if this needed */
  tweet_metadata?: Maybe<TweetMetadata>;
  youtube_metadata?: Maybe<YoutubeMetadata>;
  instagram_metadata?: Maybe<InstagramMetadata>;
  reddit_metadata?: Maybe<RedditMetadata>;
};

export type CreateClientRequestInput = {
  client_id: Scalars['ID'];
  email_address: Scalars['String'];
};

export type InstagramLocation = {
  id?: Maybe<Scalars['String']>;
  has_public_page: Scalars['Boolean'];
  name: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type InstagramMedia = {
  id: Scalars['String'];
  shortcode: Scalars['String'];
  is_video: Scalars['Boolean'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  display_url?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUser>>>;
};

export type InstagramMetadata = {
  taken_at_timestamp: Scalars['Int'];
  shortcode: Scalars['String'];
  id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  is_video: Scalars['Boolean'];
  is_ad: Scalars['Boolean'];
  owner: InstagramOwner;
  location?: Maybe<InstagramLocation>;
  tagged_users?: Maybe<Array<Maybe<InstagramTaggedUser>>>;
  media: Array<Maybe<InstagramMedia>>;
};

/**   Content / Instagram metadata */
export type InstagramOwner = {
  id: Scalars['String'];
  full_name?: Maybe<Scalars['String']>;
  is_private: Scalars['Boolean'];
  is_verified: Scalars['Boolean'];
  profile_pic_url?: Maybe<Scalars['String']>;
  profile_pic_bucket?: Maybe<Scalars['String']>;
  profile_pic_file_key?: Maybe<Scalars['String']>;
  profile_pic_width?: Maybe<Scalars['Int']>;
  profile_pic_height?: Maybe<Scalars['Int']>;
  username: Scalars['String'];
  url: Scalars['String'];
};

export type InstagramTaggedUser = {
  id: Scalars['String'];
  username: Scalars['String'];
  url: Scalars['String'];
};

export type MediaObject = {
  video?: Maybe<S3VideoObject>;
};

export enum MetadataKey {
  UrlMetadata = 'url_metadata',
  TweetMetadata = 'tweet_metadata',
  YoutubeMetadata = 'youtube_metadata',
  InstagramMetadata = 'instagram_metadata',
  RedditMetadata = 'reddit_metadata'
}

/**   Start Content */
export type MinimalUserProfile = {
  /**   id: ID! */
  full_name?: Maybe<Scalars['String']>;
  image?: Maybe<S3Object>;
};

export type Mutation = {
  /**   Create a client request */
  createClientRequest: ClientRequest;
  unsubscribeCE: Scalars['Boolean'];
  ensureInvitedUserConfirmed?: Maybe<ClientInvitation>;
};


export type MutationCreateClientRequestArgs = {
  data: CreateClientRequestInput;
};


export type MutationUnsubscribeCeArgs = {
  email_address: Scalars['String'];
};


export type MutationEnsureInvitedUserConfirmedArgs = {
  id: Scalars['ID'];
};

export enum PostType {
  Quickshare = 'quickshare',
  Manual = 'manual',
  Url = 'url',
  Tweet = 'tweet',
  Youtube = 'youtube',
  Instagram = 'instagram'
}

export type PublicContent = {
  content_id: Scalars['ID'];
  created_at: Scalars['Int'];
  publish_at: Scalars['Int'];
  content_object: ContentObject;
  user?: Maybe<MinimalUserProfile>;
  is_shareable?: Maybe<Scalars['Boolean']>;
  is_engageable?: Maybe<Scalars['Boolean']>;
  /** @deprecated Field is deprecated! */
  sharing_count?: Maybe<Scalars['Int']>;
  share_count?: Maybe<Scalars['Int']>;
  engagement_count?: Maybe<Scalars['Int']>;
  click_count?: Maybe<Scalars['Int']>;
  comment_count?: Maybe<Scalars['Int']>;
  reaction_count?: Maybe<Scalars['Int']>;
};

export type Query = {
  getAuthAndClient: AuthAndClient;
  /**   Get active client by attr */
  getActiveClientByAttr?: Maybe<Client>;
  /**   Get a client object */
  getClientByEmailDomain?: Maybe<Client>;
  /**   Get a client invitation */
  getClientInvitation?: Maybe<ClientInvitation>;
  /**   Retrieve public content */
  getPublicContent?: Maybe<PublicContent>;
};


export type QueryGetAuthAndClientArgs = {
  email_address: Scalars['String'];
};


export type QueryGetActiveClientByAttrArgs = {
  key: UniqueClientKey;
  value: Scalars['String'];
};


export type QueryGetClientByEmailDomainArgs = {
  email_domain: Scalars['String'];
};


export type QueryGetClientInvitationArgs = {
  id: Scalars['ID'];
};


export type QueryGetPublicContentArgs = {
  content_id: Scalars['ID'];
  client_id: Scalars['ID'];
};

/**   Reddit Metadata */
export type RedditMetadata = {
  archived: Scalars['Boolean'];
  author: Scalars['String'];
  author_id: Scalars['String'];
  created_utc: Scalars['Int'];
  distinguished?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  is_original_content: Scalars['Boolean'];
  is_self: Scalars['Boolean'];
  is_video: Scalars['Boolean'];
  media_only: Scalars['Boolean'];
  name: Scalars['String'];
  num_comments?: Maybe<Scalars['Int']>;
  over_18: Scalars['Boolean'];
  permalink: Scalars['String'];
  oembed_description?: Maybe<Scalars['String']>;
  oembed_height?: Maybe<Scalars['Int']>;
  oembed_width?: Maybe<Scalars['Int']>;
  oembed_html?: Maybe<Scalars['String']>;
  oembed_html_secure?: Maybe<Scalars['String']>;
  oembed_provider_name?: Maybe<Scalars['String']>;
  oembed_provider_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_url?: Maybe<Scalars['String']>;
  oembed_thumbnail_width?: Maybe<Scalars['Int']>;
  oembed_thumbnail_height?: Maybe<Scalars['Int']>;
  oembed_thumbnail_bucket?: Maybe<Scalars['String']>;
  oembed_thumbnail_file_key?: Maybe<Scalars['String']>;
  oembed_title?: Maybe<Scalars['String']>;
  oembed_type?: Maybe<Scalars['String']>;
  preview_image_url?: Maybe<Scalars['String']>;
  preview_image_width?: Maybe<Scalars['Int']>;
  preview_image_height?: Maybe<Scalars['Int']>;
  preview_image_file_key?: Maybe<Scalars['String']>;
  preview_image_bucket?: Maybe<Scalars['String']>;
  score?: Maybe<Scalars['Int']>;
  video_url?: Maybe<Scalars['String']>;
  video_width?: Maybe<Scalars['Int']>;
  video_height?: Maybe<Scalars['Int']>;
  video_duration?: Maybe<Scalars['Int']>;
  selftext?: Maybe<Scalars['String']>;
  selftext_html?: Maybe<Scalars['String']>;
  spoiler: Scalars['Boolean'];
  subreddit: Scalars['String'];
  subreddit_id: Scalars['String'];
  subreddit_name_prefixed: Scalars['String'];
  subscribers?: Maybe<Scalars['Int']>;
  subreddit_type: Scalars['String'];
  thumbnail_url?: Maybe<Scalars['String']>;
  thumbnail_width?: Maybe<Scalars['Int']>;
  thumbnail_height?: Maybe<Scalars['Int']>;
  thumbnail_bucket?: Maybe<Scalars['String']>;
  thumbnail_file_key?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  url: Scalars['String'];
};

/**   Images */
export type S3Object = {
  bucket: Scalars['String'];
  key: Scalars['String'];
  region: Scalars['String'];
  width?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
};

export type S3VideoObject = {
  bucket?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  playlist?: Maybe<Scalars['String']>;
  poster?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SsoConfiguration = {
  metadata?: Maybe<Scalars['String']>;
  metadata_url?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  identity_pool_id?: Maybe<Scalars['String']>;
  user_pool_id?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  app_client_id?: Maybe<Scalars['String']>;
};

/**   Content / Tweet Metadata fields */
export type TweetHashtag = {
  text: Scalars['String'];
};

export type TweetHashtagInput = {
  text: Scalars['String'];
};

export type TweetMedia = {
  media_url_https?: Maybe<Scalars['String']>;
  media_url_original?: Maybe<Scalars['String']>;
  media_url_proxy?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMediaInput = {
  media_url_https?: Maybe<Scalars['String']>;
  media_url_original?: Maybe<Scalars['String']>;
  media_url_proxy?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
};

export type TweetMetadata = {
  id_str: Scalars['String'];
  created_at?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  possibly_sensitive?: Maybe<Scalars['Boolean']>;
  lang?: Maybe<Scalars['String']>;
  in_reply_to_user_id_str?: Maybe<Scalars['String']>;
  in_reply_to_status_id_str?: Maybe<Scalars['String']>;
  favorite_count?: Maybe<Scalars['Int']>;
  retweet_count?: Maybe<Scalars['Int']>;
  user: TweetUser;
  place?: Maybe<TweetPlace>;
  hashtags?: Maybe<Array<Maybe<TweetHashtag>>>;
  urls?: Maybe<Array<Maybe<TweetUrl>>>;
  user_mentions?: Maybe<Array<Maybe<TweetUserMention>>>;
  media?: Maybe<Array<Maybe<TweetMedia>>>;
};

export type TweetPlace = {
  country?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TweetPlaceInput = {
  country?: Maybe<Scalars['String']>;
  full_name?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  place_type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type TweetUrl = {
  display_url?: Maybe<Scalars['String']>;
  expanded_url?: Maybe<Scalars['String']>;
};

export type TweetUrlInput = {
  display_url?: Maybe<Scalars['String']>;
  expanded_url?: Maybe<Scalars['String']>;
};

export type TweetUser = {
  id_str: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  screen_name: Scalars['String'];
  profile_image_url_https?: Maybe<Scalars['String']>;
  profile_image_url_original?: Maybe<Scalars['String']>;
  profile_image_url_proxy?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  followers_count?: Maybe<Scalars['Int']>;
  friends_count?: Maybe<Scalars['Int']>;
  lang?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  protected?: Maybe<Scalars['Boolean']>;
  statuses_count?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type TweetUserInput = {
  id_str: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  screen_name: Scalars['String'];
  profile_image_url_https?: Maybe<Scalars['String']>;
  profile_image_url_original?: Maybe<Scalars['String']>;
  profile_image_url_proxy?: Maybe<Scalars['Boolean']>;
  created_at?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  followers_count?: Maybe<Scalars['Int']>;
  friends_count?: Maybe<Scalars['Int']>;
  lang?: Maybe<Scalars['String']>;
  location?: Maybe<Scalars['String']>;
  protected?: Maybe<Scalars['Boolean']>;
  statuses_count?: Maybe<Scalars['Int']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type TweetUserMention = {
  id_str?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  screen_name?: Maybe<Scalars['String']>;
};

export type TweetUserMentionInput = {
  id_str?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  screen_name?: Maybe<Scalars['String']>;
};

/**   Clients */
export enum UniqueClientKey {
  Subdomain = 'subdomain',
  Id = 'id',
  EmailDomain = 'email_domain',
  Provider = 'provider'
}

export type UrlMetadata = {
  type: UrlMetadataType;
  provider_display?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  provider_url?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  original_url?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  safe?: Maybe<Scalars['Boolean']>;
  images?: Maybe<Array<Maybe<UrlMetadataImage>>>;
  media?: Maybe<UrlMetadataMedia>;
};

/**   Content / URL metadata fields */
export type UrlMetadataImage = {
  url: Scalars['String'];
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  url_original?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  size?: Maybe<Scalars['Int']>;
  primary?: Maybe<Scalars['Boolean']>;
};

export type UrlMetadataMedia = {
  duration?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  html?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  bucket?: Maybe<Scalars['String']>;
  file_key?: Maybe<Scalars['String']>;
  url_proxy?: Maybe<Scalars['Boolean']>;
  url_original?: Maybe<Scalars['String']>;
};

export enum UrlMetadataType {
  Html = 'html',
  Image = 'image',
  Audio = 'audio',
  Video = 'video',
  Unknown = 'unknown'
}

/**   Content / Youtube  Metadata fields */
export type YoutubeMetadata = {
  video_id: Scalars['String'];
  video_url: Scalars['String'];
  channel_id?: Maybe<Scalars['String']>;
  channel_url?: Maybe<Scalars['String']>;
  video_title?: Maybe<Scalars['String']>;
  video_description?: Maybe<Scalars['String']>;
  video_thumbnail_original_url?: Maybe<Scalars['String']>;
  video_thumbnail_bucket?: Maybe<Scalars['String']>;
  video_thumbnail_file_key?: Maybe<Scalars['String']>;
  video_thumbnail_width?: Maybe<Scalars['Int']>;
  video_thumbnail_height?: Maybe<Scalars['Int']>;
  video_published_at?: Maybe<Scalars['Int']>;
  video_player?: Maybe<Scalars['String']>;
  video_projection?: Maybe<Scalars['String']>;
  video_duration?: Maybe<Scalars['String']>;
  video_dimension?: Maybe<Scalars['String']>;
  video_definition?: Maybe<Scalars['String']>;
  channel_country?: Maybe<Scalars['String']>;
  channel_description?: Maybe<Scalars['String']>;
  channel_title?: Maybe<Scalars['String']>;
  channel_thumbnail_original_url?: Maybe<Scalars['String']>;
  channel_thumbnail_bucket?: Maybe<Scalars['String']>;
  channel_thumbnail_file_key?: Maybe<Scalars['String']>;
  channel_thumbnail_width?: Maybe<Scalars['Int']>;
  channel_thumbnail_height?: Maybe<Scalars['Int']>;
};

export type EnsureInvitedUserConfirmedMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EnsureInvitedUserConfirmedMutation = { ensureInvitedUserConfirmed?: Maybe<Pick<ClientInvitation, 'id' | 'client_id' | 'email_address' | 'invitation_status' | 'created_at' | 'updated_at'>> };

export type UnsubscribeMutationVariables = Exact<{
  email_address: Scalars['String'];
}>;


export type UnsubscribeMutation = Pick<Mutation, 'unsubscribeCE'>;

export type GetActiveClientByAttrQueryVariables = Exact<{
  key: UniqueClientKey;
  value: Scalars['String'];
}>;


export type GetActiveClientByAttrQuery = { getActiveClientByAttr?: Maybe<ClientPublicFragment> };

export type GetAuthAndClientQueryVariables = Exact<{
  email_address: Scalars['String'];
}>;


export type GetAuthAndClientQuery = { getAuthAndClient: (
    Pick<AuthAndClient, 'existing_user' | 'authentication_type'>
    & { client?: Maybe<ClientPublicFragment> }
  ) };

export type GetPublicContentQueryVariables = Exact<{
  content_id: Scalars['ID'];
  client_id: Scalars['ID'];
}>;


export type GetPublicContentQuery = { getPublicContent?: Maybe<(
    Pick<PublicContent, 'click_count' | 'content_id' | 'comment_count' | 'created_at' | 'engagement_count' | 'is_engageable' | 'is_shareable' | 'publish_at' | 'reaction_count' | 'share_count' | 'sharing_count'>
    & { user?: Maybe<(
      Pick<MinimalUserProfile, 'full_name'>
      & { image?: Maybe<Pick<S3Object, 'width' | 'height' | 'bucket' | 'key' | 'region'>> }
    )>, content_object: (
      Pick<ContentObject, 'post_type' | 'metadata_keys' | 'title' | 'body' | 'url'>
      & { photos?: Maybe<Array<Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height' | 'region'>>>>, media?: Maybe<{ video?: Maybe<Pick<S3VideoObject, 'bucket' | 'key' | 'region' | 'playlist' | 'poster' | 'thumbnails'>> }>, url_metadata?: Maybe<(
        Pick<UrlMetadata, 'provider_display' | 'provider_name' | 'provider_url' | 'title' | 'url' | 'original_url' | 'description'>
        & { images?: Maybe<Array<Maybe<Pick<UrlMetadataImage, 'url' | 'bucket' | 'file_key' | 'url_proxy' | 'url_original' | 'caption' | 'height' | 'width' | 'size' | 'primary'>>>>, media?: Maybe<Pick<UrlMetadataMedia, 'duration' | 'height' | 'width' | 'type' | 'html' | 'url' | 'bucket' | 'file_key' | 'url_proxy' | 'url_original'>> }
      )>, tweet_metadata?: Maybe<(
        Pick<TweetMetadata, 'id_str' | 'created_at' | 'text' | 'favorite_count' | 'retweet_count'>
        & { user: Pick<TweetUser, 'name' | 'screen_name' | 'profile_image_url_https' | 'verified'>, hashtags?: Maybe<Array<Maybe<Pick<TweetHashtag, 'text'>>>>, urls?: Maybe<Array<Maybe<Pick<TweetUrl, 'display_url' | 'expanded_url'>>>>, user_mentions?: Maybe<Array<Maybe<Pick<TweetUserMention, 'id_str' | 'name' | 'screen_name'>>>>, media?: Maybe<Array<Maybe<Pick<TweetMedia, 'media_url_https' | 'type'>>>> }
      )>, youtube_metadata?: Maybe<Pick<YoutubeMetadata, 'video_id'>>, instagram_metadata?: Maybe<Pick<InstagramMetadata, 'id' | 'shortcode'>>, reddit_metadata?: Maybe<Pick<RedditMetadata, 'url'>> }
    ) }
  )> };

export type ClientCommonFragment = (
  Pick<Client, 'id' | 'title' | 'subdomain' | 'email_domains' | 'content_domains' | 'client_status' | 'authentication_type' | 'allow_user_signup' | 'departments_in_signup' | 'departments_in_signup_required' | 'locations_in_signup' | 'locations_in_signup_required' | 'default_timezone' | 'default_language' | 'support_multiple_languages' | 'social_media_policy_enabled' | 'social_media_policy_title' | 'social_media_policy' | 'public_post_page' | 'public_post_details'>
  & { sso_configuration?: Maybe<Pick<SsoConfiguration, 'provider' | 'domain' | 'identity_pool_id' | 'user_pool_id' | 'region' | 'app_client_id'>>, image?: Maybe<Pick<S3Object, 'bucket' | 'key' | 'width' | 'height' | 'region'>> }
);

export type ClientPublicFragment = ClientCommonFragment;

export const ClientCommonFragmentDoc = gql`
    fragment ClientCommon on Client {
  id
  title
  subdomain
  email_domains
  content_domains
  client_status
  authentication_type
  allow_user_signup
  departments_in_signup
  departments_in_signup_required
  locations_in_signup
  locations_in_signup_required
  default_timezone
  default_language
  support_multiple_languages
  social_media_policy_enabled
  social_media_policy_title
  social_media_policy
  public_post_page
  public_post_details
  sso_configuration {
    provider
    domain
    identity_pool_id
    user_pool_id
    region
    app_client_id
  }
  image {
    bucket
    key
    width
    height
    region
  }
}
    `;
export const ClientPublicFragmentDoc = gql`
    fragment ClientPublic on Client {
  ...ClientCommon
}
    ${ClientCommonFragmentDoc}`;
export const EnsureInvitedUserConfirmedDocument = gql`
    mutation ENSURE_INVITED_USER_CONFIRMED($id: ID!) {
  ensureInvitedUserConfirmed(id: $id) {
    id
    client_id
    email_address
    invitation_status
    created_at
    updated_at
  }
}
    `;
export type EnsureInvitedUserConfirmedMutationFn = ApolloReactCommon.MutationFunction<EnsureInvitedUserConfirmedMutation, EnsureInvitedUserConfirmedMutationVariables>;
export type EnsureInvitedUserConfirmedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EnsureInvitedUserConfirmedMutation, EnsureInvitedUserConfirmedMutationVariables>, 'mutation'>;

    export const EnsureInvitedUserConfirmedComponent = (props: EnsureInvitedUserConfirmedComponentProps) => (
      <ApolloReactComponents.Mutation<EnsureInvitedUserConfirmedMutation, EnsureInvitedUserConfirmedMutationVariables> mutation={EnsureInvitedUserConfirmedDocument} {...props} />
    );
    

/**
 * __useEnsureInvitedUserConfirmedMutation__
 *
 * To run a mutation, you first call `useEnsureInvitedUserConfirmedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureInvitedUserConfirmedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureInvitedUserConfirmedMutation, { data, loading, error }] = useEnsureInvitedUserConfirmedMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnsureInvitedUserConfirmedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnsureInvitedUserConfirmedMutation, EnsureInvitedUserConfirmedMutationVariables>) {
        return ApolloReactHooks.useMutation<EnsureInvitedUserConfirmedMutation, EnsureInvitedUserConfirmedMutationVariables>(EnsureInvitedUserConfirmedDocument, baseOptions);
      }
export type EnsureInvitedUserConfirmedMutationHookResult = ReturnType<typeof useEnsureInvitedUserConfirmedMutation>;
export type EnsureInvitedUserConfirmedMutationResult = ApolloReactCommon.MutationResult<EnsureInvitedUserConfirmedMutation>;
export type EnsureInvitedUserConfirmedMutationOptions = ApolloReactCommon.BaseMutationOptions<EnsureInvitedUserConfirmedMutation, EnsureInvitedUserConfirmedMutationVariables>;
export const UnsubscribeDocument = gql`
    mutation UNSUBSCRIBE($email_address: String!) {
  unsubscribeCE(email_address: $email_address)
}
    `;
export type UnsubscribeMutationFn = ApolloReactCommon.MutationFunction<UnsubscribeMutation, UnsubscribeMutationVariables>;
export type UnsubscribeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnsubscribeMutation, UnsubscribeMutationVariables>, 'mutation'>;

    export const UnsubscribeComponent = (props: UnsubscribeComponentProps) => (
      <ApolloReactComponents.Mutation<UnsubscribeMutation, UnsubscribeMutationVariables> mutation={UnsubscribeDocument} {...props} />
    );
    

/**
 * __useUnsubscribeMutation__
 *
 * To run a mutation, you first call `useUnsubscribeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeMutation, { data, loading, error }] = useUnsubscribeMutation({
 *   variables: {
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useUnsubscribeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsubscribeMutation, UnsubscribeMutationVariables>) {
        return ApolloReactHooks.useMutation<UnsubscribeMutation, UnsubscribeMutationVariables>(UnsubscribeDocument, baseOptions);
      }
export type UnsubscribeMutationHookResult = ReturnType<typeof useUnsubscribeMutation>;
export type UnsubscribeMutationResult = ApolloReactCommon.MutationResult<UnsubscribeMutation>;
export type UnsubscribeMutationOptions = ApolloReactCommon.BaseMutationOptions<UnsubscribeMutation, UnsubscribeMutationVariables>;
export const GetActiveClientByAttrDocument = gql`
    query GET_ACTIVE_CLIENT_BY_ATTR($key: UniqueClientKey!, $value: String!) {
  getActiveClientByAttr(key: $key, value: $value) {
    ...ClientPublic
  }
}
    ${ClientPublicFragmentDoc}`;
export type GetActiveClientByAttrComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>, 'query'> & ({ variables: GetActiveClientByAttrQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetActiveClientByAttrComponent = (props: GetActiveClientByAttrComponentProps) => (
      <ApolloReactComponents.Query<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables> query={GetActiveClientByAttrDocument} {...props} />
    );
    

/**
 * __useGetActiveClientByAttrQuery__
 *
 * To run a query within a React component, call `useGetActiveClientByAttrQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveClientByAttrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveClientByAttrQuery({
 *   variables: {
 *      key: // value for 'key'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useGetActiveClientByAttrQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>) {
        return ApolloReactHooks.useQuery<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>(GetActiveClientByAttrDocument, baseOptions);
      }
export function useGetActiveClientByAttrLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>(GetActiveClientByAttrDocument, baseOptions);
        }
export type GetActiveClientByAttrQueryHookResult = ReturnType<typeof useGetActiveClientByAttrQuery>;
export type GetActiveClientByAttrLazyQueryHookResult = ReturnType<typeof useGetActiveClientByAttrLazyQuery>;
export type GetActiveClientByAttrQueryResult = ApolloReactCommon.QueryResult<GetActiveClientByAttrQuery, GetActiveClientByAttrQueryVariables>;
export const GetAuthAndClientDocument = gql`
    query GET_AUTH_AND_CLIENT($email_address: String!) {
  getAuthAndClient(email_address: $email_address) {
    existing_user
    authentication_type
    client {
      ...ClientPublic
    }
  }
}
    ${ClientPublicFragmentDoc}`;
export type GetAuthAndClientComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>, 'query'> & ({ variables: GetAuthAndClientQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetAuthAndClientComponent = (props: GetAuthAndClientComponentProps) => (
      <ApolloReactComponents.Query<GetAuthAndClientQuery, GetAuthAndClientQueryVariables> query={GetAuthAndClientDocument} {...props} />
    );
    

/**
 * __useGetAuthAndClientQuery__
 *
 * To run a query within a React component, call `useGetAuthAndClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAuthAndClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAuthAndClientQuery({
 *   variables: {
 *      email_address: // value for 'email_address'
 *   },
 * });
 */
export function useGetAuthAndClientQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>) {
        return ApolloReactHooks.useQuery<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>(GetAuthAndClientDocument, baseOptions);
      }
export function useGetAuthAndClientLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>(GetAuthAndClientDocument, baseOptions);
        }
export type GetAuthAndClientQueryHookResult = ReturnType<typeof useGetAuthAndClientQuery>;
export type GetAuthAndClientLazyQueryHookResult = ReturnType<typeof useGetAuthAndClientLazyQuery>;
export type GetAuthAndClientQueryResult = ApolloReactCommon.QueryResult<GetAuthAndClientQuery, GetAuthAndClientQueryVariables>;
export const GetPublicContentDocument = gql`
    query GET_PUBLIC_CONTENT($content_id: ID!, $client_id: ID!) {
  getPublicContent(content_id: $content_id, client_id: $client_id) {
    click_count
    content_id
    comment_count
    created_at
    engagement_count
    is_engageable
    is_shareable
    publish_at
    reaction_count
    share_count
    sharing_count
    user {
      full_name
      image {
        width
        height
        bucket
        key
        region
      }
    }
    content_object {
      post_type
      metadata_keys
      title
      body
      url
      photos {
        bucket
        key
        width
        height
        region
      }
      media {
        video {
          bucket
          key
          region
          playlist
          poster
          thumbnails
        }
      }
      url_metadata {
        provider_display
        provider_name
        provider_url
        title
        url
        original_url
        description
        images {
          url
          bucket
          file_key
          url_proxy
          url_original
          caption
          height
          width
          size
          primary
        }
        media {
          duration
          height
          width
          type
          html
          url
          bucket
          file_key
          url_proxy
          url_original
        }
      }
      tweet_metadata {
        id_str
        created_at
        text
        favorite_count
        retweet_count
        user {
          name
          screen_name
          profile_image_url_https
          verified
        }
        hashtags {
          text
        }
        urls {
          display_url
          expanded_url
        }
        user_mentions {
          id_str
          name
          screen_name
        }
        media {
          media_url_https
          type
        }
      }
      youtube_metadata {
        video_id
      }
      instagram_metadata {
        id
        shortcode
      }
      reddit_metadata {
        url
      }
    }
  }
}
    `;
export type GetPublicContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPublicContentQuery, GetPublicContentQueryVariables>, 'query'> & ({ variables: GetPublicContentQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPublicContentComponent = (props: GetPublicContentComponentProps) => (
      <ApolloReactComponents.Query<GetPublicContentQuery, GetPublicContentQueryVariables> query={GetPublicContentDocument} {...props} />
    );
    

/**
 * __useGetPublicContentQuery__
 *
 * To run a query within a React component, call `useGetPublicContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPublicContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPublicContentQuery({
 *   variables: {
 *      content_id: // value for 'content_id'
 *      client_id: // value for 'client_id'
 *   },
 * });
 */
export function useGetPublicContentQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPublicContentQuery, GetPublicContentQueryVariables>) {
        return ApolloReactHooks.useQuery<GetPublicContentQuery, GetPublicContentQueryVariables>(GetPublicContentDocument, baseOptions);
      }
export function useGetPublicContentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPublicContentQuery, GetPublicContentQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetPublicContentQuery, GetPublicContentQueryVariables>(GetPublicContentDocument, baseOptions);
        }
export type GetPublicContentQueryHookResult = ReturnType<typeof useGetPublicContentQuery>;
export type GetPublicContentLazyQueryHookResult = ReturnType<typeof useGetPublicContentLazyQuery>;
export type GetPublicContentQueryResult = ApolloReactCommon.QueryResult<GetPublicContentQuery, GetPublicContentQueryVariables>;